import Modal from "antd/es/modal/Modal";
import React from "react";
import { STRINGS } from "../../constants";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

const ExitPopup = ({ onCancel, exit, title, exitModal, setExitModal }) => {
  ExitPopup.propTypes = {
    onCancel: PropTypes.func,
    exit: PropTypes.any,
    title: PropTypes.string,
    exitModal: PropTypes.bool,
    setExitModal: PropTypes.bool,
  };
  const { t } = useTranslation();
  return (
    <div>
      <Modal
        closable={false}
        width={300}
        open={exitModal}
        onOk={() => setExitModal(false)}
        onCancel={() => setExitModal(false)}
        destroyOnClose
        centered
        footer={null}
      >
        <div>
          <h2 className="text-base font-medium text-center">{title}</h2>
          <div className="flex items-center justify-center gap-2 mt-4">
            <button
              className="px-4 py-2 border  rounded-2xl"
              onClick={() => setExitModal(false)}
            >
              {t(STRINGS?.cancel)}
            </button>
            <button
              className="px-4 py-2 border text-white bg-[#FE6B01] rounded-2xl"
              onClick={onCancel}
            >
              {exit ?? t(STRINGS?.submit)}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ExitPopup;
